<template>
  <div class="input-time-picker">
    <div class="input-wrapper" @click="toggleTimeSelector">
      <div class="input-wrapper">
        <input-text ref="hoursInput" v-model="selectedHours" inputType="number" :min="0" :max="23" :digits="2" />
        <span>:</span>
        <input-text ref="minutesInput" v-model="selectedMinutes" inputType="number" :min="0" :max="59" :digits="2" />
      </div>
      <i class="fal fa-clock"></i>
    </div>
    <div class="time-selector" v-if="showTimeSelector">
      <div ref="hoursScrollContainer" class="time-selector-hours">
        <div v-for="(h,i) in 24" :key="JSON.stringify('hour_'+i)" 
          class="option" :class="{selected: i == selectedHours}"
          @click="selectHour(i.toString().padStart(2,'0'))">
          {{ i.toString().padStart(2,'0') }}
        </div>
      </div>
      <div ref="minutesScrollContainer" class="time-selector-minutes">
        <div v-for="(m,i) in 60" :key="JSON.stringify('min_'+i)"
          class="option" :class="{selected: i == selectedMinutes}"
          @click="selectMinute(i.toString().padStart(2,'0'))">
          {{ i.toString().padStart(2,'0') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputText from './input-text';

export default {
  props: {
    hours: {
      type: [Number, String],
      default: () => 0
    },
    minutes: {
      type: [Number, String],
      default: () => 0
    },
  },

  data: function () {
    return {
      selectedHours: this.hours,
      selectedMinutes: this.minutes,
      showTimeSelector: false,
      isElementInFocus: false
    }
  },

  methods: {
    toggleTimeSelector: function () {
      this.showTimeSelector = !this.showTimeSelector;
      if (this.showTimeSelector) {
        this.$nextTick(() => {
          if (this.selectedHours !== null && this.selectedHours !== undefined) {
            this.$refs.hoursInput.$el.focus();
            this.scrollToSelected('hours');
          }
          if (this.selectedMinutes !== null && this.selectedMinutes !== undefined) {
            this.$refs.minutesInput.$el.focus();
            this.scrollToSelected('minutes');
          }
        });
      }
    },
    scrollToSelected(type) {
      this.$nextTick(() => {
        const selected = type === 'hours' ? this.selectedHours : this.selectedMinutes;
        const scrollContainer = type === 'hours' ? this.$refs.hoursScrollContainer : this.$refs.minutesScrollContainer;
        const option = scrollContainer.querySelector(`.option:nth-child(${parseInt(selected, 10) + 1})`);
        if (option) {
          scrollContainer.scrollTop = option.offsetTop - scrollContainer.clientHeight / 2 + option.clientHeight / 2;
        }
      });
    },
    selectHour: function (h) {
      this.selectedHours = h;
    },
    selectMinute: function (m) {
      this.selectedMinutes = m;
    },
  },

  watch: {
    selectedHours: function (value) {
      this.$emit('update', { hours: value, minutes: this.selectedMinutes, showTimeSelector: this.showTimeSelector });
    },
    selectedMinutes: function (value) {
      this.$emit('update', { hours: this.selectedHours, minutes: value, showTimeSelector: this.showTimeSelector });
    },
    showTimeSelector: function (value) {
      this.$emit('update', { hours: this.selectedHours, minutes: this.selectedMinutes, showTimeSelector: value });
    }
  },

  components: {
    InputText
  }
}
</script>

<style lang="scss" scoped>
  .input-time-picker {
    position:relative;
    border: 1px solid #e8e8e8;
    border-radius: 3px;
    padding: 6px 10px;
    display: flex;
    align-items: center;

    .input-wrapper {
      display: flex;
      align-items: center;
      width: 100%;
    }

    span {
      line-height: 1;
      padding-bottom: 2px;
    }

    input {
      padding: 0;
      width: 20px;
      line-height: 1;
      text-align: center;
      -moz-appearance: textfield;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        display: none;
      }
    }
    .time-selector {
      user-select: none;
      position: absolute;
      display: flex;
      flex-direction: row;
      gap: 4px;
      top: 30px;
      left:0;
      box-shadow: rgba(128,128,128,.4) 0 8px 16px;
      width: 100px;
      height: 224px;
      padding:4px;
      border:1px solid #e8e8e8;
      border-radius: 4px;
      background: rgba(255,255,255,.8);

      .time-selector-hours, 
      .time-selector-minutes {
        display: flex;
        flex:1;
        flex-direction: column;
        align-items: center;
        overflow-y: scroll;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
      }

      .time-selector-hours::-webkit-scrollbar,
      .time-selector-minutes::-webkit-scrollbar {
        display: none;
      }
      .option {
        display:flex;
        align-items: center;
        justify-content: center;
        min-width: 100%;
        padding: 8px;
        font-size: 12px;
        line-height: 12px;
        background:#fff;
        border-radius: 2px;
        margin:2px;
        color: #000;
        user-select: none;

        &:hover {
          background: #d9f1f7;
        }
        &.selected {
          background: #00a4cd;
          font-weight: bold;
          color: #fff;
        }
      }

  }
}
</style>